/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsupportedRouteImport } from './routes/unsupported'
import { Route as SettingRouteImport } from './routes/setting'
import { Route as SearchRouteImport } from './routes/search'
import { Route as NotificationRouteImport } from './routes/notification'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FollowingRouteImport } from './routes/following'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as ExperimentRouteImport } from './routes/experiment'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UUsernameRouteImport } from './routes/u.$username'
import { Route as HashtagIdRouteImport } from './routes/hashtag.$id'
import { Route as testTestRouteImport } from './routes/(test)/test'
import { Route as legacyRecommendRouteImport } from './routes/(legacy)/recommend'
import { Route as legacyMeRouteImport } from './routes/(legacy)/me'
import { Route as UUsernameIndexRouteImport } from './routes/u.$username.index'
import { Route as TopicIdIndexRouteImport } from './routes/topic.$id.index'
import { Route as UUsernameTopicRouteImport } from './routes/u.$username.topic'
import { Route as UUsernameCollectionRouteImport } from './routes/u.$username.collection'
import { Route as TopicIdTabRouteImport } from './routes/topic.$id.$tab'
import { Route as testTestUnsupportedRouteImport } from './routes/(test)/test.unsupported'
import { Route as testTestSearchRouteImport } from './routes/(test)/test.search'
import { Route as testTestNavigateRouteImport } from './routes/(test)/test.navigate'
import { Route as legacyUsersUsernameRouteImport } from './routes/(legacy)/users.$username'
import { Route as legacyTopicsIdRouteImport } from './routes/(legacy)/topics.$id'
import { Route as legacyRepostsIdRouteImport } from './routes/(legacy)/reposts.$id'
import { Route as legacyRepostIdRouteImport } from './routes/(legacy)/repost.$id'
import { Route as legacyOriginalPostsIdRouteImport } from './routes/(legacy)/originalPosts.$id'
import { Route as legacyOriginalPostIdRouteImport } from './routes/(legacy)/originalPost.$id'
import { Route as legacyHashtagsIdRouteImport } from './routes/(legacy)/hashtags.$id'
import { Route as UUsernameTypeIdIndexRouteImport } from './routes/u.$username_.$type.$id.index'
import { Route as UUsernameTypeIdCommentIdRouteImport } from './routes/u.$username_.$type.$id.$commentId'

const MoreLazyRouteImport = createFileRoute('/more')()

const MoreLazyRoute = MoreLazyRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/more.lazy').then((d) => d.Route))
const UnsupportedRoute = UnsupportedRouteImport.update({
  id: '/unsupported',
  path: '/unsupported',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingRoute = SettingRouteImport.update({
  id: '/setting',
  path: '/setting',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationRoute = NotificationRouteImport.update({
  id: '/notification',
  path: '/notification',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FollowingRoute = FollowingRouteImport.update({
  id: '/following',
  path: '/following',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreRoute = ExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperimentRoute = ExperimentRouteImport.update({
  id: '/experiment',
  path: '/experiment',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UUsernameRoute = UUsernameRouteImport.update({
  id: '/u/$username',
  path: '/u/$username',
  getParentRoute: () => rootRouteImport,
} as any)
const HashtagIdRoute = HashtagIdRouteImport.update({
  id: '/hashtag/$id',
  path: '/hashtag/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const testTestRoute = testTestRouteImport.update({
  id: '/(test)/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyRecommendRoute = legacyRecommendRouteImport.update({
  id: '/(legacy)/recommend',
  path: '/recommend',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyMeRoute = legacyMeRouteImport.update({
  id: '/(legacy)/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const UUsernameIndexRoute = UUsernameIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UUsernameRoute,
} as any)
const TopicIdIndexRoute = TopicIdIndexRouteImport.update({
  id: '/topic/$id/',
  path: '/topic/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const UUsernameTopicRoute = UUsernameTopicRouteImport.update({
  id: '/topic',
  path: '/topic',
  getParentRoute: () => UUsernameRoute,
} as any)
const UUsernameCollectionRoute = UUsernameCollectionRouteImport.update({
  id: '/collection',
  path: '/collection',
  getParentRoute: () => UUsernameRoute,
} as any)
const TopicIdTabRoute = TopicIdTabRouteImport.update({
  id: '/topic/$id/$tab',
  path: '/topic/$id/$tab',
  getParentRoute: () => rootRouteImport,
} as any)
const testTestUnsupportedRoute = testTestUnsupportedRouteImport.update({
  id: '/unsupported',
  path: '/unsupported',
  getParentRoute: () => testTestRoute,
} as any)
const testTestSearchRoute = testTestSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => testTestRoute,
} as any)
const testTestNavigateRoute = testTestNavigateRouteImport.update({
  id: '/navigate',
  path: '/navigate',
  getParentRoute: () => testTestRoute,
} as any)
const legacyUsersUsernameRoute = legacyUsersUsernameRouteImport.update({
  id: '/(legacy)/users/$username',
  path: '/users/$username',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyTopicsIdRoute = legacyTopicsIdRouteImport.update({
  id: '/(legacy)/topics/$id',
  path: '/topics/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyRepostsIdRoute = legacyRepostsIdRouteImport.update({
  id: '/(legacy)/reposts/$id',
  path: '/reposts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyRepostIdRoute = legacyRepostIdRouteImport.update({
  id: '/(legacy)/repost/$id',
  path: '/repost/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyOriginalPostsIdRoute = legacyOriginalPostsIdRouteImport.update({
  id: '/(legacy)/originalPosts/$id',
  path: '/originalPosts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyOriginalPostIdRoute = legacyOriginalPostIdRouteImport.update({
  id: '/(legacy)/originalPost/$id',
  path: '/originalPost/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const legacyHashtagsIdRoute = legacyHashtagsIdRouteImport.update({
  id: '/(legacy)/hashtags/$id',
  path: '/hashtags/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const UUsernameTypeIdIndexRoute = UUsernameTypeIdIndexRouteImport.update({
  id: '/u/$username_/$type/$id/',
  path: '/u/$username/$type/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const UUsernameTypeIdCommentIdRoute =
  UUsernameTypeIdCommentIdRouteImport.update({
    id: '/u/$username_/$type/$id/$commentId',
    path: '/u/$username/$type/$id/$commentId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/experiment': typeof ExperimentRoute
  '/explore': typeof ExploreRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notification': typeof NotificationRoute
  '/search': typeof SearchRoute
  '/setting': typeof SettingRoute
  '/unsupported': typeof UnsupportedRoute
  '/more': typeof MoreLazyRoute
  '/me': typeof legacyMeRoute
  '/recommend': typeof legacyRecommendRoute
  '/test': typeof testTestRouteWithChildren
  '/hashtag/$id': typeof HashtagIdRoute
  '/u/$username': typeof UUsernameRouteWithChildren
  '/hashtags/$id': typeof legacyHashtagsIdRoute
  '/originalPost/$id': typeof legacyOriginalPostIdRoute
  '/originalPosts/$id': typeof legacyOriginalPostsIdRoute
  '/repost/$id': typeof legacyRepostIdRoute
  '/reposts/$id': typeof legacyRepostsIdRoute
  '/topics/$id': typeof legacyTopicsIdRoute
  '/users/$username': typeof legacyUsersUsernameRoute
  '/test/navigate': typeof testTestNavigateRoute
  '/test/search': typeof testTestSearchRoute
  '/test/unsupported': typeof testTestUnsupportedRoute
  '/topic/$id/$tab': typeof TopicIdTabRoute
  '/u/$username/collection': typeof UUsernameCollectionRoute
  '/u/$username/topic': typeof UUsernameTopicRoute
  '/topic/$id': typeof TopicIdIndexRoute
  '/u/$username/': typeof UUsernameIndexRoute
  '/u/$username/$type/$id/$commentId': typeof UUsernameTypeIdCommentIdRoute
  '/u/$username/$type/$id': typeof UUsernameTypeIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/experiment': typeof ExperimentRoute
  '/explore': typeof ExploreRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notification': typeof NotificationRoute
  '/search': typeof SearchRoute
  '/setting': typeof SettingRoute
  '/unsupported': typeof UnsupportedRoute
  '/more': typeof MoreLazyRoute
  '/me': typeof legacyMeRoute
  '/recommend': typeof legacyRecommendRoute
  '/test': typeof testTestRouteWithChildren
  '/hashtag/$id': typeof HashtagIdRoute
  '/hashtags/$id': typeof legacyHashtagsIdRoute
  '/originalPost/$id': typeof legacyOriginalPostIdRoute
  '/originalPosts/$id': typeof legacyOriginalPostsIdRoute
  '/repost/$id': typeof legacyRepostIdRoute
  '/reposts/$id': typeof legacyRepostsIdRoute
  '/topics/$id': typeof legacyTopicsIdRoute
  '/users/$username': typeof legacyUsersUsernameRoute
  '/test/navigate': typeof testTestNavigateRoute
  '/test/search': typeof testTestSearchRoute
  '/test/unsupported': typeof testTestUnsupportedRoute
  '/topic/$id/$tab': typeof TopicIdTabRoute
  '/u/$username/collection': typeof UUsernameCollectionRoute
  '/u/$username/topic': typeof UUsernameTopicRoute
  '/topic/$id': typeof TopicIdIndexRoute
  '/u/$username': typeof UUsernameIndexRoute
  '/u/$username/$type/$id/$commentId': typeof UUsernameTypeIdCommentIdRoute
  '/u/$username/$type/$id': typeof UUsernameTypeIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/experiment': typeof ExperimentRoute
  '/explore': typeof ExploreRoute
  '/following': typeof FollowingRoute
  '/login': typeof LoginRoute
  '/notification': typeof NotificationRoute
  '/search': typeof SearchRoute
  '/setting': typeof SettingRoute
  '/unsupported': typeof UnsupportedRoute
  '/more': typeof MoreLazyRoute
  '/(legacy)/me': typeof legacyMeRoute
  '/(legacy)/recommend': typeof legacyRecommendRoute
  '/(test)/test': typeof testTestRouteWithChildren
  '/hashtag/$id': typeof HashtagIdRoute
  '/u/$username': typeof UUsernameRouteWithChildren
  '/(legacy)/hashtags/$id': typeof legacyHashtagsIdRoute
  '/(legacy)/originalPost/$id': typeof legacyOriginalPostIdRoute
  '/(legacy)/originalPosts/$id': typeof legacyOriginalPostsIdRoute
  '/(legacy)/repost/$id': typeof legacyRepostIdRoute
  '/(legacy)/reposts/$id': typeof legacyRepostsIdRoute
  '/(legacy)/topics/$id': typeof legacyTopicsIdRoute
  '/(legacy)/users/$username': typeof legacyUsersUsernameRoute
  '/(test)/test/navigate': typeof testTestNavigateRoute
  '/(test)/test/search': typeof testTestSearchRoute
  '/(test)/test/unsupported': typeof testTestUnsupportedRoute
  '/topic/$id/$tab': typeof TopicIdTabRoute
  '/u/$username/collection': typeof UUsernameCollectionRoute
  '/u/$username/topic': typeof UUsernameTopicRoute
  '/topic/$id/': typeof TopicIdIndexRoute
  '/u/$username/': typeof UUsernameIndexRoute
  '/u/$username_/$type/$id/$commentId': typeof UUsernameTypeIdCommentIdRoute
  '/u/$username_/$type/$id/': typeof UUsernameTypeIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/experiment'
    | '/explore'
    | '/following'
    | '/login'
    | '/notification'
    | '/search'
    | '/setting'
    | '/unsupported'
    | '/more'
    | '/me'
    | '/recommend'
    | '/test'
    | '/hashtag/$id'
    | '/u/$username'
    | '/hashtags/$id'
    | '/originalPost/$id'
    | '/originalPosts/$id'
    | '/repost/$id'
    | '/reposts/$id'
    | '/topics/$id'
    | '/users/$username'
    | '/test/navigate'
    | '/test/search'
    | '/test/unsupported'
    | '/topic/$id/$tab'
    | '/u/$username/collection'
    | '/u/$username/topic'
    | '/topic/$id'
    | '/u/$username/'
    | '/u/$username/$type/$id/$commentId'
    | '/u/$username/$type/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/experiment'
    | '/explore'
    | '/following'
    | '/login'
    | '/notification'
    | '/search'
    | '/setting'
    | '/unsupported'
    | '/more'
    | '/me'
    | '/recommend'
    | '/test'
    | '/hashtag/$id'
    | '/hashtags/$id'
    | '/originalPost/$id'
    | '/originalPosts/$id'
    | '/repost/$id'
    | '/reposts/$id'
    | '/topics/$id'
    | '/users/$username'
    | '/test/navigate'
    | '/test/search'
    | '/test/unsupported'
    | '/topic/$id/$tab'
    | '/u/$username/collection'
    | '/u/$username/topic'
    | '/topic/$id'
    | '/u/$username'
    | '/u/$username/$type/$id/$commentId'
    | '/u/$username/$type/$id'
  id:
    | '__root__'
    | '/'
    | '/experiment'
    | '/explore'
    | '/following'
    | '/login'
    | '/notification'
    | '/search'
    | '/setting'
    | '/unsupported'
    | '/more'
    | '/(legacy)/me'
    | '/(legacy)/recommend'
    | '/(test)/test'
    | '/hashtag/$id'
    | '/u/$username'
    | '/(legacy)/hashtags/$id'
    | '/(legacy)/originalPost/$id'
    | '/(legacy)/originalPosts/$id'
    | '/(legacy)/repost/$id'
    | '/(legacy)/reposts/$id'
    | '/(legacy)/topics/$id'
    | '/(legacy)/users/$username'
    | '/(test)/test/navigate'
    | '/(test)/test/search'
    | '/(test)/test/unsupported'
    | '/topic/$id/$tab'
    | '/u/$username/collection'
    | '/u/$username/topic'
    | '/topic/$id/'
    | '/u/$username/'
    | '/u/$username_/$type/$id/$commentId'
    | '/u/$username_/$type/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ExperimentRoute: typeof ExperimentRoute
  ExploreRoute: typeof ExploreRoute
  FollowingRoute: typeof FollowingRoute
  LoginRoute: typeof LoginRoute
  NotificationRoute: typeof NotificationRoute
  SearchRoute: typeof SearchRoute
  SettingRoute: typeof SettingRoute
  UnsupportedRoute: typeof UnsupportedRoute
  MoreLazyRoute: typeof MoreLazyRoute
  legacyMeRoute: typeof legacyMeRoute
  legacyRecommendRoute: typeof legacyRecommendRoute
  testTestRoute: typeof testTestRouteWithChildren
  HashtagIdRoute: typeof HashtagIdRoute
  UUsernameRoute: typeof UUsernameRouteWithChildren
  legacyHashtagsIdRoute: typeof legacyHashtagsIdRoute
  legacyOriginalPostIdRoute: typeof legacyOriginalPostIdRoute
  legacyOriginalPostsIdRoute: typeof legacyOriginalPostsIdRoute
  legacyRepostIdRoute: typeof legacyRepostIdRoute
  legacyRepostsIdRoute: typeof legacyRepostsIdRoute
  legacyTopicsIdRoute: typeof legacyTopicsIdRoute
  legacyUsersUsernameRoute: typeof legacyUsersUsernameRoute
  TopicIdTabRoute: typeof TopicIdTabRoute
  TopicIdIndexRoute: typeof TopicIdIndexRoute
  UUsernameTypeIdCommentIdRoute: typeof UUsernameTypeIdCommentIdRoute
  UUsernameTypeIdIndexRoute: typeof UUsernameTypeIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/more': {
      id: '/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof MoreLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsupported': {
      id: '/unsupported'
      path: '/unsupported'
      fullPath: '/unsupported'
      preLoaderRoute: typeof UnsupportedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setting': {
      id: '/setting'
      path: '/setting'
      fullPath: '/setting'
      preLoaderRoute: typeof SettingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notification': {
      id: '/notification'
      path: '/notification'
      fullPath: '/notification'
      preLoaderRoute: typeof NotificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/following': {
      id: '/following'
      path: '/following'
      fullPath: '/following'
      preLoaderRoute: typeof FollowingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore': {
      id: '/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof ExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiment': {
      id: '/experiment'
      path: '/experiment'
      fullPath: '/experiment'
      preLoaderRoute: typeof ExperimentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$username': {
      id: '/u/$username'
      path: '/u/$username'
      fullPath: '/u/$username'
      preLoaderRoute: typeof UUsernameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hashtag/$id': {
      id: '/hashtag/$id'
      path: '/hashtag/$id'
      fullPath: '/hashtag/$id'
      preLoaderRoute: typeof HashtagIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(test)/test': {
      id: '/(test)/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof testTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)/recommend': {
      id: '/(legacy)/recommend'
      path: '/recommend'
      fullPath: '/recommend'
      preLoaderRoute: typeof legacyRecommendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)/me': {
      id: '/(legacy)/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof legacyMeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$username/': {
      id: '/u/$username/'
      path: '/'
      fullPath: '/u/$username/'
      preLoaderRoute: typeof UUsernameIndexRouteImport
      parentRoute: typeof UUsernameRoute
    }
    '/topic/$id/': {
      id: '/topic/$id/'
      path: '/topic/$id'
      fullPath: '/topic/$id'
      preLoaderRoute: typeof TopicIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$username/topic': {
      id: '/u/$username/topic'
      path: '/topic'
      fullPath: '/u/$username/topic'
      preLoaderRoute: typeof UUsernameTopicRouteImport
      parentRoute: typeof UUsernameRoute
    }
    '/u/$username/collection': {
      id: '/u/$username/collection'
      path: '/collection'
      fullPath: '/u/$username/collection'
      preLoaderRoute: typeof UUsernameCollectionRouteImport
      parentRoute: typeof UUsernameRoute
    }
    '/topic/$id/$tab': {
      id: '/topic/$id/$tab'
      path: '/topic/$id/$tab'
      fullPath: '/topic/$id/$tab'
      preLoaderRoute: typeof TopicIdTabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(test)/test/unsupported': {
      id: '/(test)/test/unsupported'
      path: '/unsupported'
      fullPath: '/test/unsupported'
      preLoaderRoute: typeof testTestUnsupportedRouteImport
      parentRoute: typeof testTestRoute
    }
    '/(test)/test/search': {
      id: '/(test)/test/search'
      path: '/search'
      fullPath: '/test/search'
      preLoaderRoute: typeof testTestSearchRouteImport
      parentRoute: typeof testTestRoute
    }
    '/(test)/test/navigate': {
      id: '/(test)/test/navigate'
      path: '/navigate'
      fullPath: '/test/navigate'
      preLoaderRoute: typeof testTestNavigateRouteImport
      parentRoute: typeof testTestRoute
    }
    '/(legacy)/users/$username': {
      id: '/(legacy)/users/$username'
      path: '/users/$username'
      fullPath: '/users/$username'
      preLoaderRoute: typeof legacyUsersUsernameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)/topics/$id': {
      id: '/(legacy)/topics/$id'
      path: '/topics/$id'
      fullPath: '/topics/$id'
      preLoaderRoute: typeof legacyTopicsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)/reposts/$id': {
      id: '/(legacy)/reposts/$id'
      path: '/reposts/$id'
      fullPath: '/reposts/$id'
      preLoaderRoute: typeof legacyRepostsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)/repost/$id': {
      id: '/(legacy)/repost/$id'
      path: '/repost/$id'
      fullPath: '/repost/$id'
      preLoaderRoute: typeof legacyRepostIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)/originalPosts/$id': {
      id: '/(legacy)/originalPosts/$id'
      path: '/originalPosts/$id'
      fullPath: '/originalPosts/$id'
      preLoaderRoute: typeof legacyOriginalPostsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)/originalPost/$id': {
      id: '/(legacy)/originalPost/$id'
      path: '/originalPost/$id'
      fullPath: '/originalPost/$id'
      preLoaderRoute: typeof legacyOriginalPostIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(legacy)/hashtags/$id': {
      id: '/(legacy)/hashtags/$id'
      path: '/hashtags/$id'
      fullPath: '/hashtags/$id'
      preLoaderRoute: typeof legacyHashtagsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$username_/$type/$id/': {
      id: '/u/$username_/$type/$id/'
      path: '/u/$username/$type/$id'
      fullPath: '/u/$username/$type/$id'
      preLoaderRoute: typeof UUsernameTypeIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$username_/$type/$id/$commentId': {
      id: '/u/$username_/$type/$id/$commentId'
      path: '/u/$username/$type/$id/$commentId'
      fullPath: '/u/$username/$type/$id/$commentId'
      preLoaderRoute: typeof UUsernameTypeIdCommentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface testTestRouteChildren {
  testTestNavigateRoute: typeof testTestNavigateRoute
  testTestSearchRoute: typeof testTestSearchRoute
  testTestUnsupportedRoute: typeof testTestUnsupportedRoute
}

const testTestRouteChildren: testTestRouteChildren = {
  testTestNavigateRoute: testTestNavigateRoute,
  testTestSearchRoute: testTestSearchRoute,
  testTestUnsupportedRoute: testTestUnsupportedRoute,
}

const testTestRouteWithChildren = testTestRoute._addFileChildren(
  testTestRouteChildren,
)

interface UUsernameRouteChildren {
  UUsernameCollectionRoute: typeof UUsernameCollectionRoute
  UUsernameTopicRoute: typeof UUsernameTopicRoute
  UUsernameIndexRoute: typeof UUsernameIndexRoute
}

const UUsernameRouteChildren: UUsernameRouteChildren = {
  UUsernameCollectionRoute: UUsernameCollectionRoute,
  UUsernameTopicRoute: UUsernameTopicRoute,
  UUsernameIndexRoute: UUsernameIndexRoute,
}

const UUsernameRouteWithChildren = UUsernameRoute._addFileChildren(
  UUsernameRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ExperimentRoute: ExperimentRoute,
  ExploreRoute: ExploreRoute,
  FollowingRoute: FollowingRoute,
  LoginRoute: LoginRoute,
  NotificationRoute: NotificationRoute,
  SearchRoute: SearchRoute,
  SettingRoute: SettingRoute,
  UnsupportedRoute: UnsupportedRoute,
  MoreLazyRoute: MoreLazyRoute,
  legacyMeRoute: legacyMeRoute,
  legacyRecommendRoute: legacyRecommendRoute,
  testTestRoute: testTestRouteWithChildren,
  HashtagIdRoute: HashtagIdRoute,
  UUsernameRoute: UUsernameRouteWithChildren,
  legacyHashtagsIdRoute: legacyHashtagsIdRoute,
  legacyOriginalPostIdRoute: legacyOriginalPostIdRoute,
  legacyOriginalPostsIdRoute: legacyOriginalPostsIdRoute,
  legacyRepostIdRoute: legacyRepostIdRoute,
  legacyRepostsIdRoute: legacyRepostsIdRoute,
  legacyTopicsIdRoute: legacyTopicsIdRoute,
  legacyUsersUsernameRoute: legacyUsersUsernameRoute,
  TopicIdTabRoute: TopicIdTabRoute,
  TopicIdIndexRoute: TopicIdIndexRoute,
  UUsernameTypeIdCommentIdRoute: UUsernameTypeIdCommentIdRoute,
  UUsernameTypeIdIndexRoute: UUsernameTypeIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
